<template>
  <router-link
    :to="{ name: 'Project', params: { projectId: project.id } }"
    class="project-small-card"
  >
    <img
      v-if="project.profilePic"
      alt="Project Picture"
      class="project-small-card__image"
      :src="project.profilePic"
    />
    <div v-if="!project.profilePic" class="project-small-card__image"></div>
    <div class="project-small-card__info">
      <div class="project-small-card__title">{{ project.title }}</div>
      <div class="project-small-card__see-more">See More</div>
    </div>
  </router-link>
</template>

<script>
/** This component is a simpler version of ProjectCard that's used within user Profile page */
export default {
  name: 'ProjectSmallCard',
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.project-small-card {
  display: flex;
  margin: 16px;
  cursor: pointer;

  &__image {
    height: 100px;
    width: 100px;
    min-height: 100px;
    min-width: 100px;
    border-radius: 50%;
    object-fit: cover;
    background-color: $primary;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    margin-left: 16px;
  }

  &__title {
    margin-bottom: 6px;
    color: black;
  }

  &__see-more {
    font-size: 12px;
    color: $primary;
  }
}
</style>
